// extracted by mini-css-extract-plugin
export var columnItem = "_ch-3";
export var columnItemDraggable = "_ch-5";
export var dragHandle = "_ch-0";
export var dragHandleHovered = "_ch-1";
export var dropdown = "_ch-6";
export var dropdownContent = "_ch-8";
export var dropdownInner = "_ch-7";
export var filterDropdownHeader = "_ch-9";
export var icon = "_ch-2";
export var moveToTopButton = "_ch-4";
export var sectionDivider = "_ch-a";